<template>
  <div class="neutral-page">
    <div class="neutral-page__card">
      <router-link to="/" class="neutral-page__logo-link">
        <img
          :src="require('../assets/img/assuraf_sm.png')"
          class="neutral-page__logo"
          alt="Assuraf"
        />
      </router-link>

<!--      <h1 class="neutral-page__title">{{ $t('neutral_page.title') }}</h1>-->
      <p class="neutral-page__message">{{ $t('neutral_page.message') }}</p>

      <router-link to="/" class="neutral-page__button">
        {{ $t('neutral_page.bouton_home_label') }}
      </router-link>
    </div>

    <footer class="neutral-page__footer">
      <p>&copy; {{ new Date().getFullYear() }} Assuraf</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PageNeutre',
  metaInfo() {
    return {
      title: 'Assuraf',
      meta: [
        { name: 'robots', content: 'noindex, nofollow' }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style lang="less" scoped>
.neutral-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  background: #ffffff;
  text-align: center;
}

.neutral-page__card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 520px;
}

.neutral-page__logo-link {
  display: inline-block;
  margin-bottom: 32px;
}

.neutral-page__logo {
  height: 56px;
  width: auto;
}

.neutral-page__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #211b19;
  margin: 0 0 12px;
}

.neutral-page__message {
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #6b6b6b;
  margin: 0 0 32px;
}

.neutral-page__button {
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  text-transform: uppercase;
  color: #ffffff;
  background: #ffa409;
  padding: 13px 28px;
  border-radius: 30px;
  transition: 0.2s all;
}

.neutral-page__button:hover {
  background: #e6951f;
}

.neutral-page__footer {
  margin-top: 48px;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #9b9b9b;
}
</style>
